var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M9.172,16.242,12,13.414l2.828,2.828,1.414-1.414L13.414,12l2.828-2.828L14.828,7.758,12,10.586,9.172,7.758,7.758,9.172,10.586,12,7.758,14.828Z",
    transform: "translate(2 2)",
    fill: "#57575e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M14,26A12,12,0,1,0,2,14,12.014,12.014,0,0,0,14,26ZM14,4.4A9.6,9.6,0,1,1,4.4,14,9.611,9.611,0,0,1,14,4.4Z",
    transform: "translate(0 0)",
    fill: "#57575e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.12b9b1bbed9a4804bf730a8d64bdbfbf.svg";
export { ForwardRef as ReactComponent };